import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const VisualizerDriftAmplitudeYListItem = (props) => {
    const { amplitudeY, updateVisualizerSettings } = props;

    const onAmplitudeYChange = (value) => updateVisualizerSettings({ drift: { amplitudeY: value } });

    return (
        <SliderListItem
            title='Y Distance'
            displayMultiplier={2}
            value={amplitudeY}
            min={0}
            max={100}
            step={1}
            onValueChange={onAmplitudeYChange}
            toolTip='Vertical movement distance.'
        />
    );
};

const mapStateToProps = (state) => {
    const { amplitudeY } = state.createPreview.present.videoSettings.visualizer.drift;
    return { amplitudeY };
};

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerDriftAmplitudeYListItem);
